export default __webpack_public_path__ + "static/media/roboto-latin-400-normal.4673b453.woff2";